import { Star, MapPin, Clock, User } from "lucide-react";
import { CONTACT } from "@/config/contact";
const janSig = "/Jan_Signatur_Neu.png";
const tolgaSig = "/Tolga_Signatur_Neu.png";

/**
 * Thin trust strip directly under the Hero — builds instant credibility.
 * 4 signals: Google rating · Aachen NAP · Response time · Personal contact.
 */
const TrustBar = () => {
  return (
    <section
      aria-label="Vertrauen & Standort"
      className="border-y border-border/40 bg-background/60"
    >
      <div className="container mx-auto px-4 md:px-6 max-w-7xl py-5 md:py-6">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6">
          {/* Google Rating */}
          <a
            href={CONTACT.googleBusinessUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center gap-3 group"
          >
            <div className="w-10 h-10 rounded-full bg-accent/10 border border-accent/30 flex items-center justify-center shrink-0 group-hover:bg-accent/20 transition-colors">
              <Star className="w-5 h-5 text-accent fill-accent" />
            </div>
            <div className="min-w-0">
              <div className="text-sm font-semibold text-foreground leading-tight">
                4,9 / 5 auf Google
              </div>
              <div className="text-xs text-muted-foreground truncate">
                Bewertet von echten Kunden
              </div>
            </div>
          </a>

          {/* Aachen NAP */}
          <a
            href="https://maps.google.com/?q=Charlottenburger+Allee+61,+52068+Aachen"
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center gap-3 group"
          >
            <div className="w-10 h-10 rounded-full bg-accent/10 border border-accent/30 flex items-center justify-center shrink-0 group-hover:bg-accent/20 transition-colors">
              <MapPin className="w-5 h-5 text-accent" />
            </div>
            <div className="min-w-0">
              <div className="text-sm font-semibold text-foreground leading-tight">
                Standort Aachen
              </div>
              <div className="text-xs text-muted-foreground truncate">
                Aktiv in ganz NRW
              </div>
            </div>
          </a>

          {/* Response Time */}
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 rounded-full bg-accent/10 border border-accent/30 flex items-center justify-center shrink-0">
              <Clock className="w-5 h-5 text-accent" />
            </div>
            <div className="min-w-0">
              <div className="text-sm font-semibold text-foreground leading-tight">
                Antwort in &lt; 24 h
              </div>
              <div className="text-xs text-muted-foreground truncate">
                Persönlich, kein Ticket-System
              </div>
            </div>
          </div>

          {/* Personal Contact */}
          <a href="/termin" className="flex items-center gap-3 group">
            <div className="relative w-10 h-10 shrink-0">
              <img
                src={janSig}
                alt="Jan Classen"
                className="absolute left-0 top-0 w-7 h-7 rounded-full object-cover border-2 border-background bg-muted"
                loading="lazy"
                decoding="async"
              />
              <img
                src={tolgaSig}
                alt="Tolga"
                className="absolute right-0 bottom-0 w-7 h-7 rounded-full object-cover border-2 border-background bg-muted"
                loading="lazy"
                decoding="async"
              />
            </div>
            <div className="min-w-0">
              <div className="text-sm font-semibold text-foreground leading-tight group-hover:text-accent transition-colors">
                Direkter Ansprechpartner
              </div>
              <div className="text-xs text-muted-foreground truncate">
                Jan & Tolga · Gründerteam
              </div>
            </div>
          </a>
        </div>
      </div>
    </section>
  );
};

export default TrustBar;
